import Head from "next/head";
// const RATING_WIDGET_CODE = "(function(d,s,id){var js,r=0,t=d.getElementsByTagName(s)[0];if(d.getElementById(id))return;js=d.createElement(s);js.id=id;js.src='https://www.sitejabber.com/js/v2/5fab4ba0b806d/widgets.js';t.parentNode.insertBefore(js,t);}(document,'script','sj-widget'));";

function RattingScript() {
  return (
    <Head>

      {/* <script dangerouslySetInnerHTML={{ __html: RATING_WIDGET_CODE }} /> */}
    </Head>
  );
}

export default RattingScript;
